var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodcastOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C17.3137 6 20 8.68629 20 12V18C20 20.9727 17.8381 23.4405 15.0008 23.9169L15 25.5C15 26.0523 14.5523 26.5 14 26.5C13.4477 26.5 13 26.0523 13 25.5L13.0002 23.9171C10.1624 23.4411 8 20.9731 8 18V12C8 8.68629 10.6863 6 14 6ZM14 8C11.7909 8 10 9.79086 10 12H12.5C13.0523 12 13.5 12.4477 13.5 13C13.5 13.5523 13.0523 14 12.5 14H10V16H12.5C13.0523 16 13.5 16.4477 13.5 17C13.5 17.5523 13.0523 18 12.5 18H10C10 20.2091 11.7909 22 14 22C16.2091 22 18 20.2091 18 18H17C16.4477 18 16 17.5523 16 17C16 16.4872 16.386 16.0645 16.8834 16.0067L17 16H18V14H17C16.4477 14 16 13.5523 16 13C16 12.4872 16.386 12.0645 16.8834 12.0067L17 12H18C18 9.79086 16.2091 8 14 8ZM14 2C19.1894 2 23.4556 5.95287 23.9518 11.0119C24.8229 11.1112 25.5 11.8515 25.5 12.75V17.25C25.5 18.2165 24.7165 19 23.75 19C22.7835 19 22 18.2165 22 17.25V12C22 7.58172 18.4183 4 14 4C9.58172 4 6 7.58172 6 12V17.25C6 18.2165 5.2165 19 4.25 19C3.2835 19 2.5 18.2165 2.5 17.25V12.75C2.5 11.8515 3.17713 11.1112 4.04893 11.0114C4.54442 5.95287 8.81059 2 14 2Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcastOutline);
export default __webpack_public_path__ + "static/media/podcast_outline.c6dd71feb7abc46a7e2ee88cb065585e.svg";
export { ForwardRef as ReactComponent };